export function initNewsletterSignup() {
  document.querySelectorAll('[data-newsletter-placement]').forEach(form => {
    const choices = [...form.querySelectorAll('[data-members-newsletter]')];
    const validate = () => {
      if (choices[0]) choices[0].setCustomValidity(choices.some(input => input.checked) ? '' : 'Choose at least one newsletter.');
    };
    choices.forEach(input => input.addEventListener('change', validate));
    validate();
    form.addEventListener('submit', event => {
      validate();
      if (!form.checkValidity()) { event.preventDefault(); event.stopImmediatePropagation(); form.reportValidity(); return; }
      if (typeof window.gtag === 'function') window.gtag('event', 'newsletter_signup_request', {
        placement: form.dataset.newsletterPlacement,
        newsletters: choices.filter(input => input.checked).map(input => input.value.endsWith('Weekly') ? 'weekly' : 'daily').join(',')
      });
    }, true);
  });
}
